<template>
  <div>
    <el-button style="float: right;margin-right: 5px;" icon='el-icon-edit' size='mini' type='danger' @click="handleDelete()">删除</el-button>
    <el-button :loading="handleSaveLoading" style="float: right;margin-right: 5px;" @click="handleSave()" icon='el-icon-edit' size='mini' type="success">保存</el-button>
    <el-button style="float: right;margin-right: 5px;" icon='el-icon-plus' size='mini' type="primary" @click="handleNewRows()">新增</el-button>
    <h3>体系认证情况</h3>
    <el-table-edit :model="dataList" ref="editTable">
      <el-table :data="dataList" size="small" style="width: 100%" @selection-change="selectionChangeHandle" :row-class-name="rowClassName" @row-click="editAll">
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column label="序号" header-align="center" align="center" width="80px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="year" label="有效期" header-align="center" align="center">
          <template slot-scope="scope">
            <el-date-picker 
                  @change="getTime"
                  v-if="scope.row.show"
                  v-model="scope.row.year" 
                  style="width: 295px"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至" 
                  start-placeholder="开始日期" 
                  end-placeholder="结束日期">
              </el-date-picker>
              <span v-else>{{scope.row.year}}</span> 
          </template>
        </el-table-column>
        <el-table-column prop="certifyName" label="认证体系名称" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.certifyName" placeholder="认证体系名称"></el-input>
            <span v-else>{{scope.row.certifyName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="certifyOrg" label="发证机构" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.certifyOrg" placeholder="发证机构"></el-input>
            <span v-else>{{scope.row.certifyOrg}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-table-edit>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10,15,20]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
import Vue from 'vue'
import { saveSupplierCertifications, listSupplierCertifications, listInvitedForSupplier,deleteSupplierCertificationsById} from '@/controller/portal'
export default {
  computed: {
    editTable() {
      return this.$refs.editTable
    }
  },
  data () {
    return {
      handleSaveLoading:false,
      show: false,
      dataList: [],
      totalPage: 0,
      pageIndex:1,
      pageSize:10,
      year: '',
      certifyName: '',
      certifyOrg: '',
      venderInviteFid: '',
      email: '',
      // applyStatus: ''
    }
  },
  props: {
    superId: Number
  },
  mounted() {
    this.getList()
  },
  watch: {
    venderInviteFid() {
      this.getDataList()
    }
  },
  methods: {
    getTime(value) {
      debugger
      this.year = value[0] +'至'+ value[1]
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    handleNewRows () {
      this.dataList.push({
        edit: true,
      })
    },
    handleSave() {
      this.$refs.editTable.validate(valid => {
        // valid 为布尔值 代表表格正在编辑的所有字段是否验证通过
        if (valid) {
          const me = this
          // debugger
          //保存方法
          this.saveData(me.dataList)
          me.editTable.cancelRows(this.dataList, false)
          me.$refs.table.clearSelection()
        }
      })
    },
    saveData(list) {
      for (var i = 0; i < list.length; i++){
        if(list[i].year instanceof Array){
            list[i].year = list[i].year[0] + ' 至 ' + list[i].year[1]
        }
      }
      this.handleSaveLoading = true
      saveSupplierCertifications({
        'certificationList' : list,
        'inviteId': this.superId
      }).then(data => {
        if (data && data.code === '00') {
          this.$message({
            message: '操作成功',
            type: 'success',
          })
          this.getDataList()
          this.handleSaveLoading = false
        } else {
          this.handleSaveLoading = false
          this.$message.error(data.msg)
        }
      }).catch((e) => {
        this.handleSaveLoading = false
      })
    },
    getDataList() {
      listSupplierCertifications({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'inviteId' : this.superId
      }).then(data => {
        if (data && data.code === '00') {
          if (data.body.records.length > 0){
            this.dataList = data.body.records
            this.totalPage = data.body.total
          }
        } else {
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    rowClassName({
      row,
      rowIndex
    }) {
      row.rowid = rowIndex + 1;
    },
    editAll() {
      //TODO 状态判断
     //if (this.applyStatus != null) {
        this.dataList.map((i, index) => {
          i.show = true
          Vue.set(this.dataList, index, i)
        })
      // } else {
      //   this.show = false
      // }
    },
    handleDelete(row) {
      var ids = row ? [row.id] : this.dataListSelections.map(item => {
        return item.id
      })
      var rowids = row ? [row.rowid] : this.dataListSelections.map(item => {
        return item.rowid
      })
      this.$confirm(`确定对第【${rowids.join(',')}】行进行[${row ? '删除' : '删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSupplierCertificationsById(
          {
            'ids' : ids
          }
          ).then(data => {
          if (data && data.code === '00') {
            this.getDataList()
            this.$message({
              message: '删除成功',
              type: 'success',
            })
          }
        }).catch((e)=>{}).finally(()=>{})

      })
    },
    getList() {
      listInvitedForSupplier().then(data => {
        this.venderInviteFid = data.body.records[0].id
      })
    },
    // 获取当前管理员信息
    getUserInfo () {
      // this.$http({
      //   url: this.$http.adornUrl('/sys/user/info'),
      //   method: 'get',
      //   params: this.$http.adornParams()
      // }).then((result) => {
      //   const data = result.data
      //   if (data && data.code === 0) {
      //     this.email = data.user.username
      //   }
      // })
    }
  }
}
</script>
